import { motion } from "framer-motion";

const EASE = [0.76, 0, 0.24, 1];

const chapters = [
    {
        n: "01",
        title: "Task checklists",
        copy: "Every site is cleaned to a set task checklist, so the standard is the same on every visit.",
    },
    {
        n: "02",
        title: "Supervisor checks",
        copy: "Supervisors carry out documented checks and sign off daily on every site.",
    },
    {
        n: "03",
        title: "Trained teams, safe materials",
        copy: "Our teams are trained in hygiene best practice and use food-safe cleaning materials backed by manufacturer documentation.",
    },
    {
        n: "04",
        title: "Reporting and relief cover",
        copy: "Monthly quality reporting, fast relief cover so cleaning is never interrupted, and a clear process for resolving any issue.",
    },
];

export default function Manifesto() {
    return (
        <section id="standards" className="py-24 md:py-32 px-6 md:px-12 bg-mist border-y border-edge" data-testid="standards-section">
            <div className="max-w-7xl mx-auto">
                <motion.div
                    initial={{ opacity: 0, y: 32 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.9, ease: EASE }}
                    className="mb-16 md:mb-24"
                >
                    <p className="text-xs font-bold tracking-[0.25em] uppercase text-fern mb-4">The Zami standard</p>
                    <h2 className="font-serif font-medium tracking-tight leading-tight text-3xl sm:text-4xl lg:text-5xl text-forest max-w-2xl text-balance">
                        Our standards
                    </h2>
                    <p className="text-base font-light leading-relaxed tracking-wide text-fern max-w-xl mt-6">
                        Our operations meet the hygiene standards required by FMCG and food-service
                        clients and are subject to regular client audits.
                    </p>
                </motion.div>

                <div className="flex flex-col">
                    {chapters.map((c, i) => (
                        <motion.div
                            key={c.n}
                            data-testid={`manifesto-chapter-${c.n}`}
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-60px" }}
                            transition={{ duration: 0.9, ease: EASE, delay: 0.08 * i }}
                            className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 py-10 md:py-14 border-t border-edge last:border-b items-start"
                        >
                            <span className="md:col-span-3 font-serif text-6xl md:text-7xl text-sage leading-none select-none">
                                {c.n}
                            </span>
                            <h3 className="md:col-span-4 font-serif text-2xl md:text-3xl font-medium tracking-tight text-forest">
                                {c.title}
                            </h3>
                            <p className="md:col-span-5 text-base font-light leading-relaxed tracking-wide text-fern max-w-lg">
                                {c.copy}
                            </p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
